import { IProgressData } from 'src/interfaces/Progress';
import { post } from 'src/utils/apiUtils';

export const sendProgress = (data: IProgressData) => {
  post(process.env.PROGRESS_URL as string, data);
};
